import MarketingGallery from "components/marketing/MarketingGallery";
import { devices } from "constants/breakpoints";
import { useIsMobile } from "hooks";
import React from "react";

interface HowItWorksProps {
    className?: string;
}

const HowItWorks = ({ className = "" }: HowItWorksProps) => {
    const isMobile = useIsMobile({ query: devices.tablet });

    return (
        <div className={`w-full px-6 flex items-center bg-neutral ${className}`} style={{ overflowX: "clip" }}>
            <div className="max-w-[1200px] mx-auto" style={{ padding: "40px 0" }}>
                <div className="grid grid-cols-1 tablet:grid-cols-2 gap-4 items-center">
                    {!isMobile && <MarketingGallery />}
                    <div className="space-y-8">
                        <h2 className="text-3xl tablet:text-5xl font-bold tablet:font-normal text-base-content mb-8 text-center tablet:text-left relative">
                            <span className="block tablet:inline">How </span>
                            <span className="block tablet:inline">It Works</span>
                        </h2>

                        <div className="space-y-8">
                            <div className="flex items-start space-x-4">
                                <div className="flex-shrink-0">
                                    <span className="text-blue-600 font-bold tablet:text-4xl text-3xl">1</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Select Your Coverage</h3>
                                    <p className="text-gray-700">
                                        Choose the coverage amount and term length that is right for you.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-4">
                                <div className="flex-shrink-0">
                                    <span className="text-blue-600 font-bold tablet:text-4xl text-3xl">2</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Apply</h3>
                                    <p className="text-gray-700">
                                        Answer three short health questions to determine your eligibility—no extensive medical
                                        exam needed.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-4">
                                <div className="flex-shrink-0">
                                    <span className="text-blue-600 font-bold tablet:text-4xl text-3xl">3</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Enjoy Immediate Coverage</h3>
                                    <p className="text-gray-700">
                                        Once your payment is processed, you can relax and know your loved ones are more
                                        protected.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isMobile && <MarketingGallery />}
                </div>
            </div>
        </div>
    );
};

export default HowItWorks;
